import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import { useAccountStore } from "src/stores/account";
import { useViewStore } from 'src/stores/view';
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'verificationAndDelBtn',
    props: {
        btnClass: {
            type: Object,
            default: () => {
                return {};
            }
        },
        btnSize: {
            type: String,
            default: "12px"
        }
    },
    setup(__props) {
        const accountStore = useAccountStore();
        const viewStore = useViewStore();
        const vueRouter = useRouter();
        const user = computed(() => accountStore.user);
        /**
         * Verify account
         */
        function verify() {
            viewStore.toggleVerifier(true, true, 'email_verifier');
        }
        function goSettings() {
            vueRouter.push({ name: "Account Settings" });
        }
        // pending deletion
        const userMisc = computed(() => accountStore.userMisc);
        const userAccDeletion = computed(() => {
            if (!userMisc.value)
                return null;
            return userMisc.value?.ac_marked_for_deletion || null;
        });
        return (_ctx, _cache) => {
            const _component_q_btn = _resolveComponent("q-btn");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (user.value && !user.value.email_validated && !userAccDeletion.value)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        color: "accent",
                        class: _normalizeClass(["self-center q-px-sm text-weight-bold", {
                                ...__props.btnClass
                            }]),
                        label: "verify",
                        size: __props.btnSize,
                        dense: "",
                        outline: "",
                        onClick: verify
                    }, null, 8, ["class", "size"]))
                    : _createCommentVNode("", true),
                (userAccDeletion.value)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        color: "accent",
                        class: _normalizeClass(["self-center q-px-sm text-weight-bold", {
                                ...__props.btnClass
                            }]),
                        label: "Pending Deletion",
                        size: __props.btnSize,
                        dense: "",
                        outline: "",
                        onClick: goSettings
                    }, null, 8, ["class", "size"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
